import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get shouldLoad() {
    return false && window.railsEnvironment != 'test';
  }

  connect() {
    if (document.documentElement.hasAttribute("data-turbo-preview")) return;

    window.googletag.cmd.push(function() {
      window.googletag.pubads().clear();
    });

    var verticals  = JSON.parse(this.data.get("verticals"));
    var tags       = JSON.parse(this.data.get("tags"));
    var categories = JSON.parse(this.data.get("categories"));
    var location   = JSON.parse(this.data.get("location"));

    if (window.googletag.pages.search) {
      window.googletag.cmd.push(function() {
        window.googletag.pubads()
             .setTargeting('vertical', verticals)
             .setTargeting('tags-vertical', tags)
             .setTargeting('categoria', categories)
             .setTargeting('location', location);

        window.googletag.pubads().refresh([
          window.googletag.slots['search_slot1'],
          window.googletag.slots['search_slot2']
        ]);
      });
    } else {
      window.googletag.cmd.push(function() {
        window.googletag.slots['search_slot1'] = window.googletag.defineSlot('/21858406487/pag-amarelas/search-results/banner', [[320,150]], 'div-gpt-search-banner')
         .setTargeting('position', ['banner'])
         .defineSizeMapping(window.googletag.sizes.mapBannerResults)
         .addService(window.googletag.pubads());

        window.googletag.slots['search_slot2'] = window.googletag.defineSlot('/21858406487/pag-amarelas/search-results/bottom', [[1, 1],[300,250]], 'div-gpt-search-bottom')
         .setTargeting('position', ['bottom'])
         .addService(window.googletag.pubads());

        window.googletag.pubads()
           .setTargeting('vertical', verticals)
           .setTargeting('tags-vertical', tags)
           .setTargeting('categoria', categories)
           .setTargeting('location', location);

        window.googletag.enableServices();

        window.googletag.display("div-gpt-search-banner");
        window.googletag.display("div-gpt-search-bottom");

        window.googletag.pages.search = true;
      });
    }
  }
}
